import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.279 15.28a.75.75 0 0 1-1.061 0L7.999 9.06l-6.22 6.22a.75.75 0 1 1-1.061-1.06L6.94 8 .719 1.78A.75.75 0 1 1 1.779.72L8 6.942l6.22-6.22a.75.75 0 1 1 1.061 1.06L9.058 8.001l6.22 6.22a.744.744 0 0 1 0 1.06"
    }, null, -1)
  ])))
}
export default { render: render }